import { BreakRule, BreakRuleBase } from './@types/BreakRuleModel';

export class BreakRuleRepository {
    private httpService: IHttpService;

    constructor(instance: IHttpService) {
        this.httpService = instance;
    }

    async getBreakRules(): Promise<BreakRule[]> {
        try {
            const response = await this.httpService.get<TKResponse<BreakRule[]>>('/break_rules');
            return response.data
                .map((item: BreakRule) => ({ ...item, id: item.break_rule_id }))
                .sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''));
        } catch (error) {
            console.error('Error al obtener los BreakRules:', error);
            throw error;
        }
    }

    async createBreakRule(data: BreakRuleBase): Promise<BreakRule> {
        try {
            const response = await this.httpService.post<TKResponse<BreakRule>, BreakRuleBase>('/break_rules', { data });
            return response.data;
        } catch (error) {
            console.error('Error al crear el BreakRule:', error);
            throw error;
        }
    }

    async deleteBreakRules(id: number): Promise<{ status: number | string; data: BreakRule }> {
        try {
            const response = await this.httpService.delete<TKResponse<BreakRule>>(`/break_rules/${id}`);

            return { status: response.status, data: response.data };
        } catch (error) {
            console.error('Error al eliminar los BreakRules:', error);
            throw error;
        }
    }

    async updateBreakRule(id: number, data: BreakRuleBase): Promise<BreakRule> {
        try {
            const response = await this.httpService.patch<TKResponse<BreakRule>, BreakRuleBase>(`/break_rules/${id}`, { data });
            return response.data;
        } catch (error) {
            console.error('Error al actualizar el BreakRule:', error);
            throw error;
        }
    }
}
